export default __webpack_public_path__ + "ca813d89c98441a44b7fabd41373bd06.svg";